import * as _ from "lodash";
import * as React from "react";
import { useAppSelector } from "services/ApplicationState/ApplicationState";
import { shallowCompare } from "services/Helpers";

const subArrays: Record<string, string[]> = {
    "subNumber": _.times(100, n => (n + 1).toString()),
    "subAlpha": "a b c d e f g h i j k l m n o p q r s t u v w x y z".split(" "),
    "subRoman": "i ii iii iv v vi vii viii ix x xi xii xiii xiv xv xvi xvii xviii xix xx".split(" "),
};

export const computeColumnLabel = (
    numberingEnabled: boolean,
    hasTitle: boolean,
    colLabel: string[] | string | undefined,
    titledBefore: number,
    parentLabel?: string,
): string | undefined => {
    if (!numberingEnabled || !hasTitle) return undefined;
    if (typeof colLabel === "string") {
        const sep = colLabel === "subNumber" ? "." : " ";
        const subLabel = subArrays[colLabel]?.[titledBefore];
        return subLabel ? (parentLabel ? `${parentLabel}${sep}${subLabel}` : subLabel) : undefined;
    }
    return colLabel?.[titledBefore];
};

const numberings: Record<string, string[] | string> = {
    "alpha": "a b c d e f g h i j k l m n o p q r s t u v w x y z".split(" "),
    "number": _.times(100, n => (n + 1).toString()),
    "roman": "i ii iii iv v vi vii viii ix x xi xii xiii xiv xv xvi xvii xviii xix xx".split(" "),
    "subNumber": "subNumber",
    "subAlpha": "subAlpha",
    "subRoman": "subRoman",
};

export const useNumbering = (atributeName: string) => {
    const currentGroup = useAppSelector(s => s.currentGroup, shallowCompare);
    return React.useMemo(() => {
        const attr = currentGroup?.attributes?.[atributeName];
        return {
            numberingEnabled: attr !== undefined,
            numberingLevels: _.map(attr, a => {
                const val = numberings[a as keyof typeof numberings];
                return val !== undefined ? val : [];
            }),
        };
    }, [currentGroup, atributeName]);
};
